import { ComponentType, FC, ReactNode } from 'react';

import { VisuallyHidden } from '@purpur/library';
import classNames from 'classnames';

export const withA11yVisuallyHidden =
    <P extends object & { className?: string }>(
        Component: ComponentType<P>,
    ): FC<P & { children?: ReactNode; accessible: ReactNode }> =>
    ({ children, accessible, className, ...props }) => (
        <>
            <Component {...(props as P)} className={className} aria-hidden="true">
                {children}
            </Component>
            <VisuallyHidden className={classNames(className && `${className}--visually-hidden`)}>
                {accessible}
            </VisuallyHidden>
        </>
    );
